export default __webpack_public_path__ + "static/media/project1-DJI_0851.e3c01471.jpg";